/* ==========================================================================
   CL · Vitrina Especiales — parallax de pilares con GSAP ScrollTrigger
   - Pilares inclinados (3 a 5). Scrub ligado al scroll (bidireccional).
   - DESKTOP (≥750px): movimiento VERTICAL — al bajar, pilar 1 sube,
     pilar 2 baja, pilar 3 sube (alternado si hay 4-5).
   - MOBILE (<750px): movimiento HORIZONTAL — al bajar, pilar 1 va a la
     derecha, pilar 2 a la izquierda, pilar 3 a la derecha (alternado).
   - En ambos la inclinación vive en el contenedor (.clesp__tilt); los
     pilares solo se trasladan, así el ángulo se mantiene siempre.
   - gsap.matchMedia() aplica/limpia cada modo al cambiar de tamaño.
   - Degradación elegante: sin GSAP (CDN caído) queda estático.
   - Respeta prefers-reduced-motion.
   ========================================================================== */

(function () {
	'use strict';

	var reduceMotion =
		window.matchMedia &&
		window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function clamp(v, min, max) {
		return Math.min(max, Math.max(min, v));
	}

	function initSection(section) {
		if (section.dataset.clInit === 'true') return;
		section.dataset.clInit = 'true';

		if (reduceMotion) return;

		var pilares = section.querySelectorAll('.clesp__pilar');
		if (!pilares.length) return;

		var intensity = clamp(
			parseFloat(section.dataset.parallax) || 30,
			0,
			100
		);
		if (intensity === 0) return;

		// Igual que la Vitrina SEO: el desplazamiento escala con la intensidad.
		var shiftY = intensity * 0.25; // yPercent (del alto del pilar) — desktop
		var shiftX = intensity * 0.25; // xPercent (del ancho de la línea) — mobile

		gsap.registerPlugin(ScrollTrigger);

		var mm = gsap.matchMedia();

		// Desktop: vertical — impares (1 y 3) suben al bajar; pares bajan.
		mm.add('(min-width: 750px)', function () {
			pilares.forEach(function (pilar, i) {
				var dir = i % 2 === 0 ? 1 : -1;
				gsap.fromTo(
					pilar,
					{ yPercent: dir * shiftY, xPercent: 0 },
					{
						yPercent: -dir * shiftY,
						ease: 'none',
						scrollTrigger: {
							trigger: section,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					}
				);
			});
		});

		// Mobile: los pilares se vuelven LÍNEAS horizontales — al bajar,
		// las impares (1 y 3) van a la derecha y las pares (2) a la
		// izquierda; al subir, lo contrario.
		mm.add('(max-width: 749px)', function () {
			pilares.forEach(function (pilar, i) {
				var dir = i % 2 === 0 ? 1 : -1;
				gsap.fromTo(
					pilar,
					{ xPercent: -dir * shiftX, yPercent: 0 },
					{
						xPercent: dir * shiftX,
						ease: 'none',
						scrollTrigger: {
							trigger: section,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					}
				);
			});
		});
	}

	function initAll() {
		document.querySelectorAll('.clesp').forEach(initSection);
	}

	// GSAP se carga desde CDN con defer: puede no estar listo aún.
	var tries = 0;
	function waitForGsap() {
		if (window.gsap && window.ScrollTrigger) {
			initAll();
			return;
		}
		tries += 1;
		if (tries > 40) return; // ~4s: nos rendimos, queda estático
		window.setTimeout(waitForGsap, 100);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', waitForGsap);
	} else {
		waitForGsap();
	}

	document.addEventListener('shopify:section:load', function () {
		if (window.gsap && window.ScrollTrigger) {
			initAll();
			ScrollTrigger.refresh();
		}
	});
})();
